import { observer } from "mobx-react";
import { FC, useEffect, useState } from "react";
import ErrorModal from "../components/Modal/ErrorModal";
import { TABLE_ABLE } from "../constants/Features";
import { classnames } from "../utils/classnames";
import { parsingOCRStore } from "../utils/mobx/ParsingOCRStore";
import { parsingTableStore } from "../utils/mobx/ParsingTableStore";
import { resultInteractionStore } from "../utils/mobx/ResultInteractionStore";

interface ParsingResultOCRProps {
  disabled?: boolean;
}

const ParsingResultOCR: FC<ParsingResultOCRProps> = ({ disabled = false }) => {
  const {
    setAdditionalFocusIndexes,
    additionalFocusIndexes,
    hoveredBoxIds,
    setHoveredBoxIds,
    selectedBoxIds,
    setSelectedBoxIds,
    focusIndex: curIndex,
    setFocusIndex: setIndex,
    setFocusEnable,
  } = resultInteractionStore;
  const { confidenceThreshold, lineModalOn, setLineModalOn } =
    parsingTableStore;
  const { ocrLines: lineGroups, values, orgLargestId } = parsingOCRStore;
  const [isRowClicked, setIsRowClicked] = useState(false);
  const [errorOn, setErrorOn] = useState<boolean>(false);
  const [reloadFunction, setReloadFunction] = useState<() => void>(() => {});
  const [errorType, setErrorType] = useState<number>(1);
  const [blockType, setBlockType] = useState<string>("center");
  const [hoverIndex, setHoverIndex] = useState<number>(-1);
  // const [hoverTableIndex, setHoverTableIndex] = useState<number>(-1);

  useEffect(() => {
    // 이미지뷰에서 박스가 클릭되었을때만 자동 스크롤
    if (isRowClicked) {
      setIsRowClicked(false);
      return;
    }

    if (selectedBoxIds.length) {
      const boxId = selectedBoxIds[0];
      document.getElementById(`row-${boxId}`)?.scrollIntoView({
        behavior: "smooth" as ScrollBehavior,
        block: "center" as ScrollLogicalPosition,
      });
      lineGroups.forEach((lineGroup, idx) => {
        if (
          selectedBoxIds.includes(`page-${lineGroup.page}-line-${lineGroup.id}`)
        ) {
          setIndex(idx);
          return;
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedBoxIds]);

  return (
    <>
      <ErrorModal
        open={errorOn}
        setOpen={setErrorOn}
        errorType={errorType}
        closeFunction={() => {}}
        reloadFunction={reloadFunction}
      />
      <div>
        {lineGroups.length > 0 && (
          <div className="flex flex-col my-4 p-4 w-[calc(100%-1.5rem)] bg-white rounded-lg border-balck min-w-full overflow-auto --body-sm items-end">
            <table className="flex flex-col w-full order-collapse ">
              <tbody className="flex flex-col items-start justify-start w-full rounded">
                {lineGroups.map((lineGroup, idx) => {
                  const linecontent = values[idx];
                  return lineGroup ? (
                    <tr
                      className={classnames({
                        "bg-blue-50  border-grey-400 border-opacity-10":
                          !disabled &&
                          (hoverIndex === idx ||
                            curIndex === idx ||
                            (hoverIndex === -1 &&
                              hoveredBoxIds.includes(
                                `page-${lineGroup.page}-line-${lineGroup.id}`,
                              )) ||
                            (curIndex === -1 &&
                              selectedBoxIds.includes(
                                `page-${lineGroup.page}-line-${lineGroup.id}`,
                              ))),

                        "bg-white border-transparent":
                          disabled ||
                          !(
                            hoverIndex === idx ||
                            curIndex === idx ||
                            (hoverIndex === -1 &&
                              hoveredBoxIds.includes(
                                `page-${lineGroup.page}-line-${lineGroup.id}`,
                              )) ||
                            (curIndex === -1 &&
                              selectedBoxIds.includes(
                                `page-${lineGroup.page}-line-${lineGroup.id}`,
                              ))
                          ),
                        "w-full text-left text-black text-opacity-90 break-words rounded my-1":
                          true,
                      })}
                      id={`row-page-${lineGroup.page}-line-${lineGroup.id}`}
                      key={`idx:${idx}`}
                      onMouseEnter={e => {
                        if (curIndex === -1) {
                          setHoveredBoxIds([
                            `page-${lineGroup.page}-line-${lineGroup.id}`,
                          ]);
                          setHoverIndex(idx);
                        }
                      }}
                      onMouseLeave={e => {
                        if (curIndex === -1) {
                          setHoveredBoxIds([]);
                          setHoverIndex(-1);
                        }
                      }}
                      onClick={e => {
                        e.stopPropagation();
                        setIsRowClicked(true);
                        if (lineGroup.id < 0 || lineGroup.id > orgLargestId) {
                          setFocusEnable(false);
                        } else {
                          setFocusEnable(true);
                        }
                        if (curIndex !== -1 && (e.ctrlKey || e.metaKey)) {
                          if (additionalFocusIndexes.length === 0) {
                            (
                              document.activeElement as
                                | HTMLInputElement
                                | HTMLTextAreaElement
                            ).blur();
                          }
                        } else {
                          // 박스가 있을때만
                          if (lineGroup.boundingBox) {
                            setSelectedBoxIds([
                              `page-${lineGroup.page}-line-${lineGroup.id}`,
                            ]);
                          } else {
                            setSelectedBoxIds([]);
                          }
                          setIndex(idx);
                          setHoveredBoxIds([]);
                          setHoverIndex(-1);
                          setAdditionalFocusIndexes([]);
                        }
                      }}
                    >
                      <td
                        className={classnames({
                          "opacity-90 w-full p-2 flex": true,
                          "whitespace-normal": true,
                          "shadow-inline":
                            idx === curIndex ||
                            additionalFocusIndexes.includes(idx),
                          "text-[#F7493C]":
                            lineGroup.confidence != null &&
                            lineGroup.confidence < confidenceThreshold,
                        })}
                        id={`td-${idx}`}
                      >
                        <div
                          className={classnames({
                            "whitespace-pre-line focus:outline-none px-1 flex items-center":
                              true,
                            "resize-none": true,
                            "bg-transparent": true,
                            "whitespace-normal": true,
                            "pointer-events-none": !TABLE_ABLE,
                          })}
                          id={"div-" + idx}
                        >
                          {" "}
                          {linecontent}
                        </div>
                      </td>
                    </tr>
                  ) : null;
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </>
  );
};

export default observer(ParsingResultOCR);
